import axios from "axios";
// import MockAdapter from "axios-mock-adapter";
// import mockApis from "../__fakeAPI__/customerApi";
import { apiEndpoint } from "../config";
import refreshInterceptor from "./refreshInterceptor/refreshInterceptor";

const MerchantsAPI = axios.create({
  baseURL: apiEndpoint.merchants,
  headers: {
    "content-type": "application/json",
  },
});

MerchantsAPI.interceptors.request.use(refreshInterceptor);

// mockApis(new MockAdapter(MerchantsAPI));

export default MerchantsAPI;
